import React, { type Dispatch, type SetStateAction } from 'react';
import {
  Chip,
  Icon,
  ToggleButton,
  ToggleButtonGroup,
} from '@saviynt/design-system';

import { useInvertedLocalize } from '../../../../utils/localization';
import { invertedMessages } from '../../../../utils/messages';
import { TOGGLE_VALUES, type ToggleSelectionType } from '../../types';

import './LowConfidenceHeader.css';

interface LowConfidenceHeaderProps {
  toggleSelection?: ToggleSelectionType;
  setToggleSelection?: Dispatch<SetStateAction<ToggleSelectionType>>;
}

LowConfidenceHeader.defaultProps = {
  toggleSelection: TOGGLE_VALUES.VISUALIZATION,
  setToggleSelection: () => {},
};

function LowConfidenceHeader({
  toggleSelection,
  setToggleSelection,
}: LowConfidenceHeaderProps): JSX.Element {
  const l = useInvertedLocalize(invertedMessages);

  return (
    <section className='Ispm-LowConfidenceHeader'>
      <div className='Ispm-LowConfidenceHeader-contentWrapper'>
        <span className='Ispm-LowConfidenceHeader-contentWrapper-confidence'>
          Confidence:
        </span>
        <span className='Ispm-LowConfidenceHeader-contentWrapper-chip'>
          <Chip
            kind='outlined'
            color='critical'
            size='small'
            label='Low'
            className=''
          />
        </span>
        <span className='Ispm-LowConfidenceHeader-contentWrapper-confidenceText'>
          {l('The generated content may have errors or may not show at all.')}
        </span>

        <span className='Ispm-LowConfidenceHeader-contentWrapper-toggleGroup'>
          <ToggleButtonGroup
            selection={toggleSelection}
            setSelection={setToggleSelection}
            isPill>
            <ToggleButton
              icon={
                <Icon
                  className='InputField-suffixButton-icon'
                  kind='DataAnalyze'
                  size='small'
                  color='navy-900'
                />
              }
            />
            <ToggleButton
              icon={<Icon kind='Code' size='small' color='navy-900' />}
            />
          </ToggleButtonGroup>
        </span>
      </div>
    </section>
  );
}

export default LowConfidenceHeader;
